import React from "react"

const SelectForProperty = ({ options, header, value, onChange, disabled, ...other }) => {
    return (
        <>
            <label>{header}</label>
            <select {...other} onChange={(e) => onChange(e.target.value)} value={value} disabled={disabled}>
                {
                    options && options.map((item, index) => {
                        return <option key={`${index}_${item.label}`} value={item.value}>{item.label}</option>
                    })
                }
            </select>
        </>
    )
}

export default SelectForProperty;
